import { GHLLanguageKeys as e } from "./ghl-ui.es297.js";
const t = {
  name: e.dutch,
  global: {
    undo: "Ongedaan maken",
    redo: "Opnieuw uitvoeren",
    confirm: "Bevestig",
    clear: "Duidelijk",
    more: "meer",
    cancel: "Annuleren",
    update: "Bijwerken"
  },
  Popconfirm: {
    positiveText: "Bevestig",
    negativeText: "Annuleer"
  },
  Cascader: {
    placeholder: "Gelieve te selecteren",
    loading: "Bezig met laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Duidelijk",
    now: "Nu",
    confirm: "Bevestig",
    selectTime: "Selecteer Tijd",
    selectDate: "Selecteer Datum",
    datePlaceholder: "Selecteer Datum",
    datetimePlaceholder: "Selecteer Tijd en Datum",
    monthPlaceholder: "Selecteer Maand",
    yearPlaceholder: "Selecteer Jaar",
    quarterPlaceholder: "Selecteer Kwartaal",
    startDatePlaceholder: "Start Datum",
    endDatePlaceholder: "Eind Datum",
    startDatetimePlaceholder: "Start Datum en Tijd",
    endDatetimePlaceholder: "Eind Datum en Tijd",
    startMonthPlaceholder: "Start Maand",
    endMonthPlaceholder: "Einde Maand",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "Vandaag"
  },
  DataTable: {
    checkTableAll: "Selecteer alles in de tabel",
    uncheckTableAll: "Deselecteer alles in de tabel",
    confirm: "Bevestig",
    clear: "Duidelijk",
    apply: "Toepassen",
    filters: "Filters",
    sort: "Sorteren"
  },
  LegacyTransfer: {
    sourceTitle: "Bron",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Selecteer Alle",
    unselectAll: "Deselecteer Alle",
    clearAll: "Duidelijk"
  },
  Empty: {
    description: "Geen Data"
  },
  Select: {
    placeholder: "Selecteer alstublieft"
  },
  TimePicker: {
    placeholder: "Selecteer Tijd",
    positiveText: "OK",
    negativeText: "Annuleer",
    now: "Nu"
  },
  Pagination: {
    goto: "Ga naar",
    selectionSuffix: "Pagina",
    next: "Volgende",
    previous: "Vorige"
  },
  DynamicTags: {
    add: "Toevoegen"
  },
  Log: {
    loading: "Bezig met laden"
  },
  Input: {
    placeholder: "Vul alsjeblieft in"
  },
  InputNumber: {
    placeholder: "Vul alsjeblieft in"
  },
  DynamicInput: {
    create: "Maak"
  },
  ThemeEditor: {
    title: "Thema Editor",
    clearAllVars: "Wis Alle Variabelen",
    clearSearch: "Zoekopdracht Wissen",
    filterCompName: "Naam van filter component",
    filterVarName: "Naam van filter variable",
    import: "Import",
    export: "Export",
    restore: "Resetten naar standaard"
  },
  Image: {
    tipPrevious: "Vorige Afbeelding (←)",
    tipNext: "Volgende afbeelding (→)",
    tipCounterclockwise: "Tegen de klok in",
    tipClockwise: "Met de klok mee",
    tipZoomOut: "Zoom uit",
    tipZoomIn: "Zoom in",
    tipClose: "Sluiten (Esc)",
    tipOriginalSize: "Zoom in op originele grootte"
  },
  SortFilter: {
    heading: "Sorteer en filter",
    sortHeading: "Sorteer op",
    newestFirst: "Nieuwste eerst",
    oldestFirst: "Oudste eerst",
    ascending: "Oplopend",
    descending: "Afdalend",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Toepassen",
    clear: "Wissen",
    cancel: "Annuleren",
    filters: "Filters"
  },
  IconPicker: {
    noMatchingFound: "Geen overeenkomende resultaten gevonden"
  },
  Spacing: {
    margin: "Marge",
    padding: "Opvulling",
    reset: "Resetten",
    errorMsg: "De opgegeven waarde is ongeldig."
  },
  BrandColorPicker: {
    brandColors: "Merk Kleuren",
    noBrandColors: "Je hebt nog geen merk kleuren toegevoegd.",
    getStarted: "Aan de slag",
    add: "Toevoegen",
    default: "Standaard"
  },
  BrandBoard: {
    addColor: "Nieuwe Kleur Toevoegen",
    editColor: "Kleur bewerken",
    add: "Toevoegen",
    noData: "Je hebt nog geen kleuren toegevoegd.",
    invalidCode: "Ongeldige kleurcode",
    defaultColor: "Standaard Kleuren"
  }
};
export {
  t as nl
};
